<template>
  <div v-if="controls" class="refapp-video__controls">
    <button
      ref="playbackControls"
      data-refapp-tagging-target="playbackControls"
      :class="{
        'refapp-video__controls-playback': true,
        'refapp-video__controls-playback--paused': !autoplay,
      }"
      aria-label="Play / Pause"
      @click="(e) => $emit('playback', e.target)"
    ></button>
    <button
      ref="audioControls"
      data-refapp-tagging-target="audioControls"
      :class="{
        'refapp-video__controls-audio': true,
        'refapp-video__controls-audio--muted': muted,
      }"
      aria-label="Audio on/ off"
      @click="(e) => $emit('audio', e.target)"
    ></button>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
export default {
  name: 'refapp-video-controls',
  inject: ['muted', 'autoplay', 'controls'],
};
</script>
